export default "__VITE_ASSET__CLAFTR4C__"